<script>
import scrollMixin from "@/mixins/scrollMixin";
import orderMixin from "@/mixins/orderMixin";
import iconMixin from "@/mixins/iconMixin";

export default {
  mixins: [scrollMixin, orderMixin, iconMixin],
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: [String, Boolean],
      required: false,
      default: false
    }
  },
  watch: {
    visible(val) {
      val ? this.removeBodyOverflow() : this.addBodyOverflow();
    }
  },

  destroyed() {
    this.addBodyOverflow();
  }
};
</script>

<template>
  <transition name="zoom" mode="in-out">
    <section v-if="visible">
      <div class="content">
        <div class="header">
          <img v-if="icon" :src="iconSrc" :height="iconSize" :alt="iconAlt" />
          <h1 v-if="title">{{title}}</h1>
          <slot name="header"></slot>
        </div>
        <div class="body">
          <slot name="body"></slot>
        </div>
      </div>
    </section>
  </transition>
</template>

<style scoped>
section {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10;
  margin: 0 !important;
}

.content {
  max-width: calc(100% - 20px);
  max-height: calc(100vh - 20px);
  background-color: #fff;
  border-radius: 4px;
  overflow: auto;
}

.header {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid #f7f7f9;
  padding: 20px 20px 10px 20px;
}

.body {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 20px 30px 20px;
  background-color: #f9f9fb;
  text-align: center;
  border-radius: 0 0 4px 4px;
}

h1 {
  text-align: center;
  font-weight: 400;
  margin-top: 15px;
  color: var(--purple);
}

@media (min-width: 321px) {
  .header {
    padding: 40px 20px 10px 20px;
  }
  .body {
    padding: 10px 20px 30px 20px;
  }
}
@media (min-width: 768px) {
  .content {
    max-width: 650px;
  }
  .header {
    padding: 40px 80px 10px 80px;
  }
  .body {
    padding: 10px 80px 30px 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Dialog.vue